<template>
  <section
    id="approach"
    class="bg-spruce-950 text-white"
  >
    <div class="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div class="max-w-4xl mb-10">
        <p class="mb-3 text-xs font-semibold uppercase tracking-[0.1em] text-spruce-300">
          Build or Partner
        </p>
        <h2 class="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
          You can build this capability internally. Or you can start from a governed foundation.
        </h2>
        <p class="text-lg text-white/70">
          A GMP-ready AI operating model is achievable, but the platform, control, and validation effort is substantial. The decision is not whether it can be done. It is how much time and internal capacity you want to spend building the control layer yourself.
        </p>
      </div>

      <div class="mb-8 grid gap-4 md:grid-cols-2">
        <article class="rounded-xl border border-white/15 bg-white/5 p-5">
          <p class="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-spruce-300">
            Trusted Delivery Base
          </p>
          <h3 class="mb-2 text-lg font-semibold text-white">
            Microsoft Partner
          </h3>
          <p class="text-sm text-white/75">
            QikSolve delivers on a Microsoft-aligned foundation, bringing regulated workflow design and delivery discipline to enterprise Microsoft environments.
          </p>
        </article>

        <article class="rounded-xl border border-white/15 bg-white/5 p-5">
          <p class="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-spruce-300">
            Platform Choice
          </p>
          <h3 class="mb-2 text-lg font-semibold text-white">
            Built with Microsoft Azure and AI Services
          </h3>
          <p class="text-sm text-white/75">
            The solution approach uses Microsoft Azure and AI platform services to support controlled, traceable AI workflows in regulated operating contexts.
          </p>
        </article>
      </div>

      <div class="grid gap-0 overflow-hidden rounded-2xl border border-white/15 lg:grid-cols-2">
        <article class="border-b border-white/10 bg-white/5 p-6 lg:border-b-0 lg:border-r lg:border-r-white/10">
          <h3 class="mb-3 text-xl font-semibold">
            Building it internally
          </h3>
          <ul class="space-y-2 text-white/75 list-disc pl-5">
            <li>Define governance policies, quality gates, and review responsibilities for each workflow.</li>
            <li>Design and validate evidence, reporting, and traceability patterns.</li>
            <li>Implement security, escalation, testing, and controlled change processes.</li>
            <li>Maintain validation evidence and continuous improvement over time.</li>
          </ul>
        </article>

        <article class="bg-spruce-100 p-6 text-neutral-900">
          <h3 class="mb-3 text-xl font-semibold">
            Working with QikSolve
          </h3>
          <ul class="space-y-2 text-neutral-700 list-disc pl-5">
            <li>Governed platform patterns and quality-gate discipline are already in place.</li>
            <li>Evidence, evaluation, and reporting models are designed for controlled environments.</li>
            <li>Security, escalation, and delivery controls are built into the operating approach.</li>
            <li>Your team can focus on high-value quality workflows instead of platform invention.</li>
          </ul>
        </article>
      </div>
    </div>
  </section>
</template>
